module.exports = __webpack_public_path__ + "img/pretesticon_0.447ad990.png";